<h1 class="primary-color">Okresowy raport spraw</h1>
<mat-stepper linear #stepper>
    <mat-step [stepControl]="form">
        <ng-template matStepLabel>Wybór zakresu</ng-template>
        <div class="container">
            <form [formGroup]="form">
                <app-search-customer label="Zlecający" formControlName="instructingId"></app-search-customer>
                <app-search-lessor-group formControlName="instructingGroupId"></app-search-lessor-group>
                <app-simple-checkbox-value-accessor label="Pomiń sprawy karne" formControlName="omitCriminalCases"></app-simple-checkbox-value-accessor>
                <app-search-by-date-from-to label="Data utworzenia w systemie" formControlName="createdAt"></app-search-by-date-from-to>
                <mat-divider class="width-100 divider"></mat-divider>
                <h3 class="primary-color">Filtry alternatywne (wystarczy jeden spełniony warunek z grupy)</h3>
                <app-simple-tri-state-button-value-accessor label="Status - trwający" formControlName="onGoing"></app-simple-tri-state-button-value-accessor>
                <div class="or-indicator">lub</div>
                <app-search-by-date-from-to label="Data zakończenia w dziale" formControlName="endAt"></app-search-by-date-from-to>
                <div class="date-actions">
                    <button mat-raised-button
                            color="accent"
                            (click)="setPreviousMonth()">
                        <mat-icon>arrow_upward</mat-icon>
                        Ostatni miesiąc
                    </button>
                    <button mat-raised-button
                            color="accent"
                            (click)="setCurrentMonth()">
                        <mat-icon>arrow_upward</mat-icon>
                        Obecny miesiąc
                    </button>
                </div>
                <mat-divider class="width-100 divider"></mat-divider>
            </form>
        </div>
    </mat-step>
    <mat-step [formGroup]="columnForm">
        <ng-template matStepLabel>Wybór kolumn</ng-template>
        <div *ngIf="isPredefinedAvailable" class="predefined-note">
          <button mat-stroked-button action-button [action]="export.bind(this, true)">
            Pobierz Predefiniowany
          </button>
          <p id="predefined-option">Lub
          <p>Stwórz wybierając odpowiednie kolumny</p>
        </div>
        <app-column-select-form formControlName="columns"></app-column-select-form>
        <button mat-stroked-button class="export-button" action-button [action]="export.bind(this, false)">
            Pobierz
        </button>
    </mat-step>
</mat-stepper>
